import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["log", "button", "icon"]

  toggle() {
    const isNowHidden = this.logTarget.classList.toggle("d-none")
    const expanded = !isNowHidden

    // Update button text
    this.buttonTarget.childNodes[0].textContent = expanded ? "Hide log " : "Show log "

    // Update icon (solid arrows)
    this.iconTarget.classList.toggle("toggle-icon--rotated", expanded)

    // this.iconTarget.classList.toggle("bi-caret-down-fill", !expanded)
    // this.iconTarget.classList.toggle("bi-caret-up-fill", expanded)
  }
}
